// Turns a JSON.parse SyntaxError's "position" (all V8-family engines
// include one, though the exact wording varies) into a line/column so the
// error message can point at the right spot instead of just "somewhere".
const positionToLineCol = (text, position) => {
  let line = 1
  let col = 1
  for (let i = 0; i < position && i < text.length; i++) {
    if (text[i] === '\n') {
      line += 1
      col = 1
    } else {
      col += 1
    }
  }
  return { line, col }
}

export const parseJson = (text) => {
  try {
    return { value: JSON.parse(text), error: null }
  } catch (err) {
    const match = /position (\d+)/.exec(err.message)
    const position = match ? Number(match[1]) : null
    const location = position !== null ? positionToLineCol(text, position) : null
    return {
      value: null,
      error: {
        message: err.message,
        line: location?.line,
        column: location?.column ?? location?.col,
      },
    }
  }
}

export const formatJson = (value) => JSON.stringify(value, null, 2)

const yamlScalar = (value) => {
  if (value === null) return 'null'
  if (typeof value === 'string') {
    return /^[\w./-]+$/.test(value) && value !== '' ? value : JSON.stringify(value)
  }
  return String(value)
}

const toYaml = (value, indent) => {
  const pad = '  '.repeat(indent)
  if (Array.isArray(value)) {
    if (value.length === 0) return `${pad}[]\n`
    return value
      .map((item) => {
        if (item !== null && typeof item === 'object') {
          const nested = toYaml(item, indent + 1)
          return `${pad}-\n${nested}`
        }
        return `${pad}- ${yamlScalar(item)}\n`
      })
      .join('')
  }
  if (value !== null && typeof value === 'object') {
    const keys = Object.keys(value)
    if (keys.length === 0) return `${pad}{}\n`
    return keys
      .map((key) => {
        const child = value[key]
        if (child !== null && typeof child === 'object') {
          return `${pad}${key}:\n${toYaml(child, indent + 1)}`
        }
        return `${pad}${key}: ${yamlScalar(child)}\n`
      })
      .join('')
  }
  return `${pad}${yamlScalar(value)}\n`
}

export const jsonToYaml = (value) => toYaml(value, 0).trimEnd()
